
import { createContext, useReducer } from "react";
import AgentReducer from "./AgentReducer";

const INITIAL_STATE = {
    agents: [],
    count: 1,
    isFetching: false,
    error: false,
    agent: {},
    isFetchingAdd: false,
    errorAdd: false,
    isFetchingUpdate: false,
    errorUpdate: false,
    isFetchingActivate: false,
    errorActivate: false,
};

export const AgentContext = createContext(INITIAL_STATE);

export const AgentContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(AgentReducer, INITIAL_STATE);
    
    return (
      <AgentContext.Provider
        value={{
          agents: state.agents,
          count: state.count,
          isFetching: state.isFetching,
          error: state.error,
          agent: state.agent,
          isFetchingAdd: state.isFetchingAdd,
          errorAdd: state.errorAdd,
          isFetchingUpdate: state.isFetchingUpdate,
          errorUpdate: state.errorUpdate,
          isFetchingActivate: state.isFetchingActivate,
          errorActivate: state.errorActivate,
          dispatch,
        }}
      >
        {children}
      </AgentContext.Provider>
    );
  };